module.exports = __webpack_public_path__ + "img/flow1.a8b8a529.png";